const LOCALE_SUFFIX_REGEXP = /\/\w{2}(?:-\w{2})?\//;

const trimLocaleSuffixFromPath = (path) => path.replace(LOCALE_SUFFIX_REGEXP, '/');

export default trimLocaleSuffixFromPath;
